export default __webpack_public_path__ + "c7690958a71c8badfed12817d4fb063a.png";